import React from "react";
import { Box, Typography, Button } from "@mui/material";
import {
  BRAND_COLOR,
  BRAND_HOVER,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

interface NoInvoiceFoundProps {
  onAddClick?: () => void;
}

const NoInvoiceFound: React.FC<NoInvoiceFoundProps> = ({ onAddClick }) => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      gap={3}
    >
      <Typography variant="h6" color="text.primary" fontWeight="bold">
        {t("no-invoices-found", "No invoices found")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t(
          "no-invoices-found-description",
          "Invoices are typically created from Purchase Orders or Sales Orders"
        )}
      </Typography>
      {onAddClick && (
        <Box>
          <Button
            variant="contained"
            onClick={onAddClick}
            sx={{
              backgroundColor: BRAND_COLOR,
              "&:hover": { backgroundColor: BRAND_HOVER },
              textTransform: "none"
            }}
          >
            {t("view-orders", "View Orders")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default NoInvoiceFound;
